export function formatDuration(milliseconds: number): string {
  if (milliseconds < 60_000) {
    const seconds = milliseconds / 1000;
    return `${seconds < 10 && !Number.isInteger(seconds) ? seconds.toFixed(1) : Math.round(seconds)} s`;
  }
  if (milliseconds < 3_600_000) return `${Math.floor(milliseconds / 60_000)} m`;
  const hours = milliseconds / 3_600_000;
  return `${hours < 10 && !Number.isInteger(hours) ? hours.toFixed(1) : Math.round(hours)} h`;
}
